import $ from 'jquery';
import 'magnific-popup';
import attachEnterAsClick from 'utils/attachEnterAsClick';

// Programatically click the auto open modal links
function attachAutoOpenModals() {
    const $modalLinks = $('.js-open-modal.js-auto-open');
    if (!$modalLinks.length) { return; }

    $modalLinks.click();
}

// Add event to a js close modal item to close the target modal
function attachCloseModalBtn(elementId) {
    const $closeModal = $(elementId).find('.js-close-modal');
    if (!$closeModal.length) { return; }

    $closeModal.click(e => {
        e.preventDefault();
        $closeModal.magnificPopup('close');
    });
    attachEnterAsClick($closeModal);
}

// Move the close X to top of the container for accessibility purpose
function attachCloseCrossKeyEvent(elementId) {
    const $closeModal = $(elementId).find('.mfp-close');
    if (!$closeModal.length) { return; }

    attachEnterAsClick($closeModal);
}

// Export this create magnificPopup function so it can be used by other scrxipts
export default function createMagnificPopup(element) {
    const targetId = $(element).attr('href');
    $(element).magnificPopup({
        type: 'inline',
        removalDelay: 500, // delay removal by X to allow out-animation
        midClick: true,
        mainClass: $(element).data('mfp-class') ? $(element).data('mfp-class') : 'mfp-fade-modal',
        fixedContentPos: true,
        callbacks: {
            open() {
                attachCloseModalBtn(targetId);
                attachCloseCrossKeyEvent(targetId);

                // custom modal style
                if ($(element).data('type-class')) {
                    $(targetId).addClass($(element).data('type-class'));
                    $('body').addClass($(element).data('type-class'));
                }
            },
            close() {
                // custom modal style
                if ($(element).data('type-class')) {
                    $('body').removeClass($(element).data('type-class'));
                }
            }
        }
    });
}

// Init the modal open links
function attachModalLinks() {
    const $modalLinks = $('.js-open-modal');
    if (!$modalLinks.length) { return; }

    $modalLinks.each(function () {
        createMagnificPopup(this);
    });
}

// Run the functions on document ready
$(() => {
    attachModalLinks();
    attachAutoOpenModals();
});



// WEBPACK FOOTER //
// ./src/components/modal/c-modal.js